import clsx from "clsx";
import classes from "./ListItem.module.css";
import List from "../List/List";

interface ListItemInterface {
  li: any;
  noVideo: boolean;
  url: string;
  oneVideo: boolean;
  onParagraphClick: any;
}

const ListItem = ({
  li,
  noVideo,
  oneVideo,
  url,
  onParagraphClick,
}: ListItemInterface) => {
  if (li?.innerlist !== undefined) {
    return (
      <li key={li.url}>
        <div
          onClick={() => !oneVideo && !noVideo && onParagraphClick(li.url)}
          dangerouslySetInnerHTML={{ __html: li.content }}
          style={{
            backgroundColor: li.url === url ? "white" : undefined,
            listStyle: li?.nomarker ? "none" : undefined,
          }}
          className={clsx(classes.description, classes.li, [
            !oneVideo && !noVideo && classes.clickable,
          ])}
        />
        <List
          url={url}
          onParagraphClick={onParagraphClick}
          noVideo={noVideo}
          list={li.innerlist}
        />
      </li>
    );
  }

  return (
    <li
      style={{
        backgroundColor: li.url === url ? "white" : undefined,
        listStyle: li?.nomarker ? "none" : undefined,
      }}
      className={clsx(classes.description, classes.li, [
        !oneVideo && !noVideo && classes.clickable,
      ])}
      onClick={() => !oneVideo && !noVideo && onParagraphClick(li.url)}
      dangerouslySetInnerHTML={{ __html: li.content }}
      key={li.url}
    />
  );
};

export default ListItem;
